import TabPage from "./../factories/tab-page";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../bindings/foreach-selection";
import "./../bindings/slide-visible";
import "./../bindings/sorting";
import "./../bindings/bao-pager";
import "./../bindings/bao-toolbar2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoMenu from "./../services/bao-menu";
import baoRouter from "./../services/bao-router";
import TabPagePreview from "./../factories/tab-page-preview";
import BaoDialog from "./../factories/bao-dialog";

export interface ISearchObject {
    SearchKey: KnockoutObservable<string> | string;
}
export interface ILayoutResult {
    PageSize: number;
    Mode: string;
    PreviewMode: boolean;
    Template: string;
    SortingVisible: boolean;
}
class SearchModel {
    TabPage: TabPage;
    Bao = Bao;
    ExpandedSearch = null;
    CurrentSearchObject = {};
    SearchKeyChanged = false;
    ChangeSearchInProgress = true;
    SearchAutoCompleteKey: KnockoutComputed<string>;
    NoResultMessage: KnockoutComputed<string>;

    //observables
    SelectionMode = ko.observable("single");
    PageModeContinousId = "00000000-0000-0000-0000-000000000001";
    PageModePagingId = "00000000-0000-0000-0000-000000000002";
    SearchExecuted = ko.observable(false);
    SearchFinished = ko.observable(false);
    SelectedSearchObject = ko.observable();
    LayoutList = ko.observableArray([]);
    SortColumnList = ko.observableArray([]);
    AvailableSearchObjects = ko.observableArray<ISearchObject>();
    ExecuteSearch = ko.observable(false);
    TabName = ko.observable<string>();
    PlaceholderSearch = ko.observable<string>();
    LayoutKey = ko.observable();
    SortingVisible = ko.observable();
    SortColumnKey = ko.observable();
    SearchKey = ko.observable<string>();
    SearchText = ko.observable<string>("");
    SearchTextTemp = ko.observable("");
    PageIndex = ko.observable(0);
    PageSize = ko.observable(25);
    PagingMode = ko.observable();
    /** Will be set by SearchObject's ExpandedSearch-ViewModel (this.ExpandedSearch)
     */
    CustomFilter = ko.observable();
    CustomFilterTemp = ko.observable();
    SelectedItem = ko.observable();
    TotalRows = ko.observable(0);
    Sorting = ko.observableArray([]);
    Grouping = ko.observableArray([]);
    PreviousSearchKey = ko.observable();
    ExpandedSearchTemplateName = ko.observable();
    ExpandedSearchVisible = ko.observable(false);
    UniqueLayoutKey = ko.observable();
    ColumnLayoutId = ko.observable<string>("");
    Models = ko.observableArray([]);
    Selection = ko.observableArray();
    Initialized = ko.observable(false);
    SearchTextEnabled = ko.observable(true);
    WebUrlNew = ko.observable<string>();
    NewAllowed = ko.observable(false);
    PreviewMode = ko.observable<boolean>(false);
    SelectedPreviewItem = ko.observable<any>(null);
    SearchSystemSettings = ko.observableArray();
    NewSearchMode = ko.observable<boolean>(false);
    AvailableColumns = ko.observableArray([]);

    //Methods
    private _buildModels(models, level, root, parent) {
        if (models != null) {
            ko.utils.arrayForEach(models, function (m: any) {
                m.__Children = ko.observableArray();
                m.__Level = level;
                m.__Root = root;
                m.__Opened = ko.observable(false);
                m.__Loaded = ko.observable(false);
                m.__Parent = parent;
                if (m.selected == undefined) {
                    m.selected = ko.observable(false);
                }
                m.__ExpandedIcon = ko.computed(function () {
                    if (m.__Opened()) {
                        return "fa-minus-square";
                    }
                    else {
                        return "fa-plus-square";
                    }
                });
            });
        }
        return models;
    }

    ChangeSearch = (newSearchKey) => {
        let def = $.Deferred();
        if (this.ChangeSearchInProgress == false && (this.Initialized() == false ||
            newSearchKey.toLowerCase() != this.SearchKey().toLowerCase() || this.SearchKeyChanged)) {
            this.TabPage.IsLoading(true);
            this.ChangeSearchInProgress = true;
            this.SearchFinished(false);
            def.then(() => {
                this.TabPage.IsLoading(false);
                this.ChangeSearchInProgress = false;
            });
            if (this.AvailableSearchObjects != null) {
                let searchObject = this.GetSearchObject(newSearchKey);
                if (searchObject != null) {
                    this.Models([]);
                    this.SearchKey(searchObject.SearchKey());
                    this.SortColumnList([]);
                    this.Sorting([]);
                    this.PageIndex(0);
                    this.TotalRows(0);
                    this.UniqueLayoutKey(null);
                    if (this.PreviousSearchKey() != null) {
                        Bao.post("Search/SaveSearchKey", JSON.stringify({ searchKey: this.SearchKey() }));
                    }
                    this.PreviousSearchKey(this.SearchKey());
                    this.WebUrlNew(searchObject.WebUrlNew());
                    this.NewAllowed(searchObject.NewAllowed());
                    this.LayoutList(searchObject.LayoutObjects());
                    this.Selection([]);
                    return $.when(
                        Bao.post("Search/GetSearchItemColumns", JSON.stringify({ searchKey: this.SearchKey() })),
                        this.RefreshExpandedSearch(false), Bao.post("Search/GetLayout", JSON.stringify({
                            searchKey: this.SearchKey(),
                            layoutKey: this.LayoutKey(), type: "Default"
                        }
                        ), (templateResult: ILayoutResult) => {
                            this.SetLayoutValues(templateResult);
                        })
                    ).then((result) => {
                        if (result != null) {
                            this.SortColumnList(result[0]);
                        }
                        return Bao.post("Search/GetAvailableColumns", JSON.stringify({ searchKey: this.SearchKey() }));
                    })
                        .then(columns => {
                            this.AvailableColumns(columns);
                            this.NewSearchMode(columns && columns.length > 0 ? true : false);
                            this.SearchFocus();
                            this.Initialized(true);
                            this.UpdateHash();
                            def.resolve();
                            return def.promise();
                        });
                }
                else {
                    def.resolve();
                }
            }
            else {
                def.resolve();
            }
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    GetSearchObject = (newSearchKey) => {
        let searchObject = null;
        for (let i = 0; i < this.AvailableSearchObjects().length; i++) {
            let item = this.AvailableSearchObjects()[i];
            if (ko.unwrap(item.SearchKey).toLowerCase() == newSearchKey.toLowerCase()) {
                searchObject = item;
                break;
            }
        }
        return searchObject;
    };
    ChangeSearchKey = (value) => {
        this.ChangeSearch(value);
    };
    SearchFocus() { }
    ResetCustomFilter = () => {
        if (this.ExpandedSearch != null && this.ExpandedSearch.Reset != null && typeof this.ExpandedSearch.Reset == "function") {
            this.ExpandedSearch.Reset();
        }
        this.RefreshExpandedSearch(true);
    };
    RefreshExpandedSearch = (setLoading) => {
        let def = $.Deferred();
        this.CustomFilter(null);
        this.ExpandedSearch = null;
        this.ExpandedSearchTemplateName(null);
        this.ExpandedSearchVisible(false);
        if (setLoading == null) {
            setLoading = true;
        }
        if (setLoading) {
            this.TabPage.IsLoading(true);
        }
        let searchKeyStart = this.SearchKey();
        this.SearchTextEnabled(true);
        Bao.post("Search/GetExpandedSearchJavaScript", JSON.stringify({ searchKey: this.SearchKey() }), (result) => {
            if (result != "") {
                window.baorequire([result], (expandedViewModel) => {
                    if (searchKeyStart == this.SearchKey()) {
                        this.ExpandedSearch = new expandedViewModel(this);
                        this.ExpandedSearch.init().then(() => {
                            if (setLoading) {
                                this.TabPage.IsLoading(false);
                            }
                            def.resolve();
                        });
                    }
                }, def.resolve);
            }
            else {
                if (setLoading) {
                    this.TabPage.IsLoading(false);
                }
                def.resolve();
            }
        }).fail(def.resolve);
        return def.promise();
    };
    ToggleExpandedSearch() {
        this.ExpandedSearchVisible(!this.ExpandedSearchVisible());
    }
    ;
    UpdateSelectedPreviewItem = () => {
        if (this.PreviewMode() && this.Selection() != null && this.Selection().length == 1) {
            let selectedItem = this.Selection()[0];
            let templateKey = this.SearchKey() + this.LayoutKey() + "_preview";
            //let templateLoaded = Bao.Templates[templateKey] != null;
            let fakeTabPage: TabPagePreview = this.CreatePreviewTabPage(selectedItem, templateKey);
            //if (!templateLoaded) {
            this.TabPage.IsLoading(true);
            this.LoadPreviewTemplate(selectedItem).then((template) => {
                this.TabPage.IsLoading(false);
                if (template != null && template != "") {
                    Bao.Templates[templateKey] = template;
                    this.SelectedPreviewItem(fakeTabPage);
                }
            });
            //} else {
            //    this.SelectedPreviewItem(fakeTabPage);
            //}
        }
        else {
            this.SelectedPreviewItem(null);
        }
    };
    private CreatePreviewTabPage = (item, templateName) => {
        let fakeTabPage = new TabPagePreview(this);
        fakeTabPage.ObjectId(ko.unwrap(item.PrimaryKeyValue));
        fakeTabPage.UrlData({ id: ko.unwrap(item.PrimaryKeyValue) });
        fakeTabPage.TemplateName(templateName);
        fakeTabPage.IsLoading = this.TabPage.IsLoading;
        return fakeTabPage;
    };
    LoadPreviewTemplate = (item: any): JQueryPromise<any> => {
        let foundRoute: any = baoRouter.findRoute(item.OpenUrl);
        if (foundRoute != null && foundRoute.length > 0) {
            return Bao.get(foundRoute[0].url);
        }
        else {
            let def = $.Deferred();
            def.resolve();
            return def.promise();
        }
    };
    private _ajaxGetLayout = null;
    GetLayout = () => {
        this.TabPage.IsLoading(true);
        if (this._ajaxGetLayout != null) {
            this._ajaxGetLayout.abort();
        }
        let searchKeyStart = this.SearchKey();
        this._ajaxGetLayout = Bao.post("Search/GetLayout", JSON.stringify({ searchKey: this.SearchKey(), layoutKey: this.LayoutKey(), type: "Default" }), (templateResult: ILayoutResult) => {
            this.SetLayoutValues(templateResult);
            this.TabPage.IsLoading(false);
            if (this.ExecuteSearch() == true) {
                this.PerformSearch();
                this.ExecuteSearch(false);
            }
            this._ajaxGetLayout = null;
        });
        return this._ajaxGetLayout;
    };
    private SetLayoutValues(templateResult: ILayoutResult) {
        this.PageSize(templateResult.PageSize);
        if (templateResult.Mode == null) {
            this.PagingMode("disabled");
        }
        else {
            this.PagingMode(templateResult.Mode);
        }
        this.SortingVisible(templateResult.SortingVisible);
        this.PreviewMode(templateResult.PreviewMode);
        Bao.Templates[this.SearchKey() + this.LayoutKey()] = templateResult.Template;
        this.UniqueLayoutKey(this.SearchKey() + this.LayoutKey());
        this.ColumnLayoutId("search_" + this.UniqueLayoutKey());
    }
    ResetFilter = () => {
        this.CustomFilter(null);
    };
    BeforeChangeSelectionOnPreviewMode = (item): JQueryPromise<boolean> => {
        let def = $.Deferred<boolean>();
        //1)There was no element selected
        if (this.Selection().length == 0) {
            //Es muss nicht abgefragt werden ob das zuvor ausgewählte Element gespeichert werden soll
            return def.resolve(true).promise();
        }
        //2)There was a element selected
        return this.SelectedPreviewItem().ViewModel()["BeforeClose"](() => { })
            .then((canBeClosed) => {
                def.resolve(canBeClosed);
                return def.promise();
            });
    };
    GetSearchItem = (index, viewModel) => {
        let def = $.Deferred();
        let indexFrom = this.PageIndex() * this.PageSize();
        let indexTo = indexFrom + this.PageSize() - 1;
        let foundItem;
        if (index >= indexFrom && index <= indexTo) {
            let currentRowIndex = index - this.PageIndex() * this.PageSize();
            def.resolve(this.Models()[currentRowIndex]);
        }
        else {
            let customFilter = this.GetCustomFilter();
            Bao.post("Search/SearchItems", JSON.stringify({
                searchKey: this.SearchKey(), searchString: this.SearchText(), customFilter: customFilter, pageIndex: index,
                pageSize: 1, sorting: this.Sorting()
            }), function (searchResult) {
                if (searchResult != null && searchResult.Models != null) {
                    def.resolve(searchResult.Models[0]);
                }
                else {
                    def.resolve(null);
                }
            });
        }
        return def.promise();
    };
    PerformSearch = (resetIndex?: boolean) => {
        this.SearchTextTemp(this.SearchText());
        this.CustomFilterTemp(this.CustomFilter());
        this.Search(true);
    };
    PerformNewObject = (resetIndex) => {
        baoRouter.setHash(this.WebUrlNew());
    };
    Search = (resetIndex) => {
        this.UpdateHash();
        Bao.raiseEvent("searched", null);
        this.TabPage.IsLoading(true);
        if (resetIndex == null) {
            resetIndex = true;
        }
        if (resetIndex) {
            this.PageIndex(0);
        }
        this.SearchExecuted(true);
        let customFilter = this.GetCustomFilter();
        this.Selection([]);
        if (this.NewSearchMode()) {
            Bao.raiseEvent("table-control:load", this.SearchKey());
        }
        else {
            Bao.post("Search/SearchItems", JSON.stringify({
                searchKey: this.SearchKey(),
                searchString: this.SearchTextTemp(),
                customFilter: customFilter,
                pageIndex: this.PageIndex(),
                pageSize: this.PageSize(),
                sorting: this.Sorting(),
                grouping: this.Grouping()
            }), (searchResult) => {
                this.TabPage.IsLoading(false);
                this.SearchExecuted(false);
                if (searchResult != null) {
                    if (searchResult.Models != null) {
                        this.TotalRows(searchResult.TotalRows);
                        this.Models(this._buildModels(searchResult.Models, 0, this, null));
                    }
                }
                this.SearchFinished(true);
            });
        }
    };

    /**
    * Get all of the rows for the DataGrid depending on the supplied parameters
    * @param headerFilters - Filters used in the request URL (see {@link https://learn.microsoft.com/en-us/odata/concepts/queryoptions-overview})
    * @param skip - The number of rows to skip
    * @param take - The number of rows to take
    * @param sortingParam - The columns to sort by and the direction to sort
    * @param groupingParam - The columns to group by
    */
    loadTableControlData = async (headerFilters, skipParam, takeParam, sortingParam, groupingParam) => {
        this.TabPage.IsLoading(true);
        let customFilters = this.GetCustomFilter();

        customFilters.push({ Key: "IncludeDeleted", Value: false });

        let url = groupingParam !== null && groupingParam.length > 0 ? "Search/SearchGroups" : "Search/SearchItems";

        if (headerFilters?.length > 0) {
            url += "?$filter=" + headerFilters;
            url = encodeURI(url);
        }

        let searchPayload = {
            searchKey: this.SearchKey === undefined ? "" : this.SearchKey(),
            searchString: this.SearchTextTemp(),
            customFilter: customFilters,
            skip: skipParam,
            take: takeParam,
            sorting: sortingParam,
            grouping: groupingParam
        };

        let searchResult;

        if (groupingParam !== null && groupingParam.length > 0) {
            searchResult = await this.executeSearchGroups(url, searchPayload);
        }
        else {
            searchResult = await this.executeSearchItems(url, searchPayload);
        }

        this.TabPage.IsLoading(false);
        this.SearchFinished(true);

        return searchResult;
    }

    /**
    * Asynchronously posts a search request for groups and processes the response.
    * @param {string} url - The URL for the request.
    * @param {Object} payload - The request data.
    * @returns {Promise<Object|null>} The processed search result or null.
    */
    executeSearchGroups = async (url, payload) => {
        const searchResult = await Bao.post(url, JSON.stringify(payload));
        return searchResult != null ? {
            data: searchResult.Models,
            groupCount: searchResult.GroupCount,
            totalCount: searchResult.TotalCount
        } : null;
    }

    /**
    * Asynchronously posts a search request for items and processes the response.
    * @param {string} url - The URL for the request.
    * @param {Object} payload - The request data.
    * @returns {Promise<Object|null>} The processed search result or null.
    */
    executeSearchItems = async (url, payload) => {
        const searchResult = await Bao.post(url, JSON.stringify(payload));
        return searchResult != null ? {
            data: searchResult.Models,
            totalCount: searchResult.TotalRows
        } : null;
    }

    /**
    * Asynchronously retrieves model metadata.
    * @returns {Promise<any>} A promise resolving to the model metadata.
    */
    loadModelMetadata = () => {
        return Bao.post("Search/GetModelMetadata", JSON.stringify({
            searchKey: ko.unwrap(this.SearchKey)
        })).then(result => {
            return result?.EdmModel;
        });
    }

    GetChildren = (item) => {
        let def = $.Deferred<void>();
        if (item != null && item.__Loaded() != true) {
            this.TabPage.IsLoading(true);
            Bao.post("Search/GetChildren", JSON.stringify({ parentId: ko.unwrap(item.PrimaryKeyValue), searchKey: this.SearchKey(), sorting: this.Sorting() }), (result) => {
                this.TabPage.IsLoading(false);
                item.__Children(this._buildModels(result, item.__Level + 1, this, item));
                item.__Opened(true);
                item.__Loaded(true);
                def.resolve();
            });
        }
        else if (item != null) {
            item.__Opened(!item.__Opened());
            if (item.__Opened() == false) {
                this.CloseChildren(item.__Children);
            }
            def.resolve();
        }
        return def.promise();
    };
    CloseChildren = (children) => {
        if (children != null && children().length > 0) {
            ko.utils.arrayForEach(children(), (c: any) => {
                c.__Opened(false);
                this.CloseChildren(c.__Children);
            });
        }
    };
    Export = (mode?: string) => {
        this.TabPage.IsLoading(true);
        Bao.post("Search/ExportData", JSON.stringify({
            searchKey: this.SearchKey(),
            layoutKey: this.LayoutKey(),
            searchString: this.SearchText(),
            sorting: this.Sorting(),
            customFilter: this.GetCustomFilter()
        }), (value) => {
            this.TabPage.IsLoading(false);
            baoRouter.setHash("#document/" + value);
        });
    };
    SearchNextPage = () => {
        if (this.TabPage.IsActiveTab()) {
            this.SearchExecuted(true);
            this.PageIndex(this.PageIndex() + 1);
            let customFilter = this.GetCustomFilter();
            this.TabPage.IsLoading(true);
            Bao.post("Search/SearchItems", JSON.stringify({
                searchKey: this.SearchKey(), searchString: this.SearchTextTemp(), customFilter: customFilter, pageIndex: this.PageIndex(),
                pageSize: this.PageSize(), sorting: this.Sorting()
            }), (result) => {
                this.SearchExecuted(false);
                if (result != null) {
                    if (result.Models != null) {
                        this.TotalRows(result.TotalRows);
                        let item, underlyingArray = this.Models();
                        for (let i = 0, j = result.Models.length; i < j; i++) {
                            item = result.Models[i];
                            underlyingArray.push(item);
                        }
                        this.Models.valueHasMutated();
                        this.TabPage.IsLoading(false);
                    }
                }
            });
        }
    };
    Open = (index, item) => {
        if (item != null) {
            this.CurrentSearchObject = { totalCount: this.TotalRows(), rowIndex: this.PageIndex() * this.PageSize() + index, id: item.OpenData };
            if (!item.OpenUrl) {
                if (this.SearchKey() === 'ConfigurationItems') {
                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNoWebUrlForConfigurationItemSearchObject"), "info");
                }
                else {
                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNoOpenUrlForSearchObject"), "info");
                }
                return null;
            }

            this.TabPage.IsLoading(true);
            if (item.OpenUrl.startsWith("#")) {
                this.TabPage.IsLoading(false);
                return true;
            }
            else {
                this.SelectedItem(item);
                window.baorequire(["Factories/TabPage", "Services/AppTabController"], (TabPage, AppTabController) => {
                    let newTab = new TabPage();
                    newTab.Url(item.OpenUrl);
                    newTab.UrlData({ id: item.OpenData });
                    newTab.ObjectId(item.OpenData);
                    newTab.Object = { searchObject: this.CurrentSearchObject };
                    AppTabController.AddTab(newTab);
                    this.TabPage.IsLoading(false);
                });
            }
        }
        return null;
    };
    GetCustomFilter = () => {
        let iObject = 0;
        let customFilterHashObject = [];
        if (this.CustomFilterTemp() != null) {
            $.each(this.CustomFilterTemp(), (key, value) => {
                let hashObject: any = {};
                hashObject.Key = key;
                hashObject.Value = value;
                customFilterHashObject[iObject] = hashObject;
                iObject++;
            });
        }
        return customFilterHashObject;
    };
    UpdateValuesFromHash = () => {
        let def = $.Deferred();
        let urlSearchKey = baoRouter.getRouteValue("searchkey", this.TabPage);
        let urlSearchText = baoRouter.getRouteValue("searchtext", this.TabPage);
        if (urlSearchKey != null) {
            urlSearchKey = decodeURIComponent(urlSearchKey);
            let searchObject = this.GetSearchObject(urlSearchKey);
            if (searchObject != null) {
                this.SearchKey(searchObject.SearchKey());
            }
            def.resolve();
        }
        else {
            this.TabPage.IsLoading(true);
            Bao.post("Search/GetSearchKey", (result) => {
                this.TabPage.IsLoading(false);
                if (result != null && result.searchKey != null && result.searchKey != "") {
                    this.ChangeSearch(result.searchKey);
                }
                def.resolve();
            });
        }
        if (urlSearchText != null) {
            urlSearchText = decodeURIComponent(urlSearchText);
            this.SearchText(urlSearchText);
        }
        if (urlSearchText != null || urlSearchKey != null) {
            this.ExecuteSearch(true);
        }
        return def.promise();
    };
    UpdateHash = () => {
        if (this.TabPage.IsActiveTab()) {
            let newHash = "search/" + this.SearchKey();
            if (!Bao.Utils.String.IsNullOrWhitespace(this.SearchText())) {
                newHash = newHash + "/" + encodeURIComponent(this.SearchText());
            }
            let currentHash = baoRouter.getHash();
            if (newHash.toLowerCase() != currentHash.toLowerCase()) {
                if (currentHash.toLowerCase() == "search") {
                    baoRouter.replaceHash(newHash);
                }
                else {
                    baoRouter.setHash(newHash);
                }
                this.TabPage.Route.request = newHash;
            }
        }
    };
    TabSelected = () => {
        this.SearchFocus();
        if (this.ChangeSearchInProgress == false) {
            this.UpdateValuesFromHash();
            this.UpdateHash();
        }
    };
    loaded = () => {
        BaoMenu.permissionEnable({ ActionKey: "SearchExport", Enabled: false, Context: this.TabPage.Context() });
        this.TabPage.TabSelected = this.TabSelected;
        this.SearchFocus();
        if (this.TabPage.IsActiveTab()) {
            this.ChangeSearchInProgress = false;
            this.UpdateValuesFromHash().then(() => {
                this.ChangeSearch(this.SearchKey());
            });
        }
        else {
            this.ChangeSearchInProgress = false;
            this.ChangeSearch(this.SearchKey());
        }
    };
    init = () => {
        this.TabPage.IsClosable(false);
        return Bao.post("Search/Model", (result) => {
            ko.map.fromJS(result, this);
        });
    };

    constructor(tabPage: TabPage) {
        this.TabPage = tabPage;
        tabPage.MenuEvents.push(BaoMenu.registerEvent((value) => {
            switch (value.ActionKey()) {
                case "SearchExport":
                    this.Export();
                    break;
            }
        }));
        this.SearchAutoCompleteKey = ko.computed(() => {
            return this.SearchKey() + "_SearchText";
        });
        this.NoResultMessage = ko.computed(() => {
            let msg = Bao.Session.GetMessage("NoResultMessage");
            let s = msg().replace("#SearchText#", this.SearchTextTemp());
            return s;
        });
        //subscribes
        this.SearchTextEnabled.subscribe(() => {
            if (this.SearchTextEnabled() == false) {
                this.SearchText("");
            }
        });
        this.PageIndex.subscribe(() => {
            if (this.PagingMode() == this.PageModePagingId) {
                if (this.SearchExecuted() == false && this.ChangeSearchInProgress == false) {
                    this.Search(false);
                }
            }
        });
        this.PageSize.subscribe(() => {
            if (this.PagingMode() == this.PageModePagingId) {
                if (this.SearchExecuted() == false && this.ChangeSearchInProgress == false) {
                    this.Search(true); //PageIndex must be reseted, because Count of PageNumbers changed!
                }
            }
        });
        this.TabName.subscribe((value: string) => {
            if (value != "") {
                this.TabPage.Title(value);
            }
        });
        this.SearchKey.subscribe((newValue) => {
            this.SearchKeyChanged = true;
            this.ChangeSearch(newValue);
            this.SearchKeyChanged = false;

            if (this.SearchKey() == "InformationSearchV2") {
                BaoMenu.permissionVisible({ ActionKey: "SearchExport", Visible: false, Context: tabPage.Context() });
            }
            else {
                BaoMenu.permissionVisible({ ActionKey: "SearchExport", Visible: true, Context: tabPage.Context() });
            }
        });
        this.LayoutKey.subscribe((newValue) => {
            if (newValue != null && this.ChangeSearchInProgress == false) {
                this.GetLayout();
            }
        });
        this.SortColumnKey.subscribe((newValue) => {
            if (newValue != null) {
                if (this.PagingMode() != this.PageModePagingId && this.PagingMode() != null) {
                    this.Sorting([{ Column: newValue, Direction: 'Ascending' }]);
                }
                else {
                    this.Sorting([]);
                }
            }
        });
        this.Sorting.subscribe(() => {
            if (this.SearchExecuted() == false && this.Models().length > 0 && this.ChangeSearchInProgress == false) {
                this.Search(true);
            }
        });
        this.TotalRows.subscribe(() => {
            BaoMenu.permissionEnable({ ActionKey: "SearchExport", Enabled: this.TotalRows() > 0, Context: tabPage.Context() });
        });
        this.Selection.subscribe(() => {
            this.UpdateSelectedPreviewItem();
        });


        Bao.post("Search/GetSearchSystemSettings", (result) => {
            this.SearchSystemSettings(result);
        });
        Bao["Search"] = this;
    }
}
export default SearchModel;